export default __webpack_public_path__ + "static/media/OsdeVenta.2b135912.png";